import React from 'react'

import RegionalResult from '../../../models/RegionalResult'
import Party from '../../../models/Party'
import Utilities from '../../../utils/Utilities'
import { PartyResultCell } from '../Cells/PartyResultCell'

interface IProps {
  regionalResult: RegionalResult | null
}

class RegionalResultTableRow extends React.Component<IProps> {
  public render(): JSX.Element {
    const { regionalResult } = this.props

    if (!regionalResult) {
      return <tr />
    }

    const seatCells = Party.allPartiesArray().map(
      (party): JSX.Element => (
        <PartyResultCell
          className="pt-3 SeatCell"
          key={party.key}
          party={party}
          areaResult={regionalResult}
          accessor={(result): number => result.seatCount}
        />
      )
    )

    const voteCells = Party.allPartiesArray().map(
      (party): JSX.Element => (
        <PartyResultCell
          className="pb-3"
          key={party.key}
          party={party}
          areaResult={regionalResult}
          accessor={(result): number => result.votePercent}
          formatter={Utilities.formatPercent}
        />
      )
    )

    return (
      <React.Fragment>
        <tr className="BorderTop">
          <td
            className="align-middle text-right pr-3 font-weight-bold"
            rowSpan={2}
          >
            <span className="d-none d-sm-inline">
              {regionalResult.region.name}
              <br />
              <small>{regionalResult.totalSeatCount} seats</small>
            </span>
            <span className="d-sm-none">{regionalResult.region.shortName}</span>
          </td>
          <td className="pt-3">Seats</td>
          {seatCells}
        </tr>
        <tr>
          <td className="pb-3">Vote %</td>
          {voteCells}
        </tr>
      </React.Fragment>
    )
  }
}

export default RegionalResultTableRow
